import React from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"
import _size from "lodash/size"

import ContentView from "scenes/Customer/components/ContentView"
import DescriptionList from "components/DescriptionList"

const Content = ({ infos, isList, classNames }) => {
  if (!_size(infos)) return null

  if (isList) {
    return (
      <ContentView classNames={classNames}>
        {_map(infos, (info, index) => {
          const isFirst = index === 0
          const isLast = index + 1 === infos.length

          return (
            <DescriptionList
              key={`${index}_${info.description}`}
              first={isFirst}
              last={isLast}
              description={`${info.description}:`}
              value={info.value}
              hasDivider
              direction={info.direction || "row"}
            />
          )
        })}
      </ContentView>
    )
  }

  return (
    <ContentView classNames={classNames}>
      <DescriptionList
        key="summary"
        description={`${infos.description}:`}
        value={infos.value}
        hasDivider
        direction="col"
      />
    </ContentView>
  )
}

Content.propTypes = {
  infos: PropTypes.array,
  isList: PropTypes.bool,
  classNames: PropTypes.string
}

export default Content



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/RequestTrackingModal/Content.js